import Layer2 from './Base';

export default function FlareFunctions({ session }) {
  return <Layer2 page="FLARE Functions" />;
}
